export default "__VITE_ASSET__Dg53oU8A__"